import { css } from '@emotion/react'

import Colours from '@thebeansgroup/ui_style_helpers/colours'

export const faq = css`
  margin-top: 48px;
`

export const counter = css`
  margin-left: 4px;
`

export const icon = css`
  opacity: 0.2;
  height: 20px;
`

export const error = css`
  color: ${Colours('alertRed', '300')};
`

export const description = css`
  margin-bottom: 36px;
  margin: 0 auto 36px auto;
`

export const faqList = css`
  margin-top: 8px;
  margin-bottom: 0;
  padding: 0 8px;
`
